'use strict';

exports.__esModule = true;
exports.getReviewReportUrl = exports.isPageOwned = exports.buildMetaDescription = exports.buildMetaTitle = undefined;

var _sanitizeHtml = require('sanitize-html');

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GOOGLE_APPROX_MAX_TITLE_LENGTH = 57;

var buildMetaTitle = exports.buildMetaTitle = function buildMetaTitle(props) {
	var titleString = (props.practice && props.practice.name) + ' - ' + (props.practice && props.practice.address && props.practice.address.city) + ' - Book Online | Doctify';
	if (titleString.length > GOOGLE_APPROX_MAX_TITLE_LENGTH) {
		return titleString.substring(0, GOOGLE_APPROX_MAX_TITLE_LENGTH).concat('...');
	}
	return titleString;
};

var buildMetaDescription = exports.buildMetaDescription = function buildMetaDescription(props) {
	var practice = props.practice || null;
	var practiceAddress = practice && practice.address;

	var name = practice && practice.name;
	var street1 = practiceAddress && practiceAddress.street1;
	var street2 = practiceAddress && practiceAddress.street2;
	var postcode = practiceAddress && practiceAddress.postcode;
	var city = practiceAddress && practiceAddress.city;
	var about = practice && practice.attributes && practice.attributes.about;

	return ('Book online now at ' + (name || '') + ', ' + (street1 ? street1 + ', ' : '') + (street2 ? street2 + ', ' : '') + (postcode ? postcode + ', ' : '') + (city ? city + '.' : '') + ' Read patient reviews and find specialists. ' + (about ? '' + (0, _sanitizeHtml2.default)(about, { allowedTags: [] }) : '')).substring(0, GOOGLE_APPROX_MAX_TITLE_LENGTH).concat('...');
};

var isPageOwned = exports.isPageOwned = function isPageOwned(session, id) {
	return session && id && (session.profiles || []).reduce(function (profileList, profile) {
		return [].concat(profileList, [profile.id, profile.uuid, profile.uri_id, profile.profile_id, profile.profile_uri]);
	}, []).includes(id);
};

var getReviewReportUrl = exports.getReviewReportUrl = function getReviewReportUrl(review) {
	return 'reviews/' + review.id + '/flag_inappropriate_report';
};


// WEBPACK FOOTER //
// ./components/practice-page/lib/utils/utils.js